import React from 'react';

const colors: Record<string, string> = {
  green: 'bg-green-100 text-green-700',
  red: 'bg-red-100 text-red-700',
  yellow: 'bg-yellow-100 text-yellow-700',
  amber: 'bg-amber-100 text-amber-800',
  orange: 'bg-orange-100 text-orange-800',
  blue: 'bg-blue-100 text-blue-700',
  gray: 'bg-gray-100 text-gray-600',
  purple: 'bg-purple-100 text-purple-700',
};

const statusColors: Record<string, string> = {
  active: 'green', online: 'green', connected: 'green', paid: 'green', answered: 'green', occupied: 'green', enabled: 'green', healthy: 'green', success: 'green', locked: 'green', closed: 'green',
  inactive: 'gray', vacant: 'gray', canceled: 'gray', cancelled: 'gray', void: 'gray', archived: 'gray', disabled: 'gray', unknown: 'gray',
  offline: 'red', suspended: 'red', error: 'red', failed: 'red', disconnected: 'red', denied: 'red', overdue: 'red', expired: 'red', past_due: 'red', alarm: 'red', revoked: 'red',
  pending: 'amber', missed: 'amber', open: 'amber', invited: 'amber', trialing: 'amber', trial: 'amber', setup: 'amber', provisioning: 'amber', unlocked: 'amber', door_open: 'amber', degraded: 'amber', idle: 'amber',
};

export const Badge: React.FC<{ status?: string; color?: string; children: React.ReactNode }> = ({ status, color, children }) => {
  const normalizedStatus = status?.trim().toLowerCase().replace(/[\s-]+/g, '_');
  const c = color || (normalizedStatus ? statusColors[normalizedStatus] || 'gray' : 'gray');
  return <span className={`inline-flex items-center justify-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colors[c] || colors.gray}`}>{children}</span>;
};
